import { render, staticRenderFns } from "./PaymentTariffRuleImport.vue?vue&type=template&id=3e6c8570&lang=pug"
import script from "./PaymentTariffRuleImport.vue?vue&type=script&lang=js"
export * from "./PaymentTariffRuleImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports